import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseRequestsDeclinedPayload } from '../payloads/requestsDeclinedPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildRequestsDeclinedInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseRequestsDeclinedPayload(payload);
  const { data } = parsedPayload.data.attributes;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.DONUT)
      .setProps({
        chartData: data as BarChartData,
        onDrillDown: props.onDrillDown,
        valueFieldName: 'request_count',
        categoryFieldName: 'declination_reason',
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
      trendData: {
        value:
          parsedPayload.data.attributes.aggregate.declined_requests.current ??
          0,
        trend:
          parsedPayload.data.attributes.aggregate.declined_requests
            .percentage_change ?? 0,
        trendIsPercent: true,
        description: props.name,
      },
    });
  };
};
